import { STORAGE_KEY } from "@constants";
import logger from "@utils/logger";

/**
 * Get storage key for promotion page landed count
 */
const getStorageKey = (memberId: string): string => {
  return `${STORAGE_KEY.PROMOTION_PAGE_LANDED_COUNT}:${memberId}`;
};

/**
 * Get promotion page landed count for a member
 * @param memberId - Member ID
 * @returns Count of page visits (defaults to 0)
 */
export const getPromotionPageLandedCount = (memberId: string): number => {
  try {
    const key = getStorageKey(memberId);
    const stored = localStorage.getItem(key);
    if (stored === null) {
      return 0;
    }
    const count = parseInt(stored, 10);
    if (isNaN(count)) {
      logger._console.warn(`Invalid promotion page landed count for member ${memberId}, resetting to 0`);
      localStorage.removeItem(key);
      return 0;
    }
    return count;
  } catch (error) {
    logger._console.error("Failed to get promotion page landed count", error);
    return 0;
  }
};

/**
 * Increment promotion page landed count for a member
 * @param memberId - Member ID
 */
export const incrementPromotionPageLandedCount = (memberId: string): void => {
  try {
    const key = getStorageKey(memberId);
    const currentCount = getPromotionPageLandedCount(memberId);
    const newCount = currentCount + 1;
    localStorage.setItem(key, newCount.toString());
  } catch (error) {
    logger._console.error("Failed to increment promotion page landed count", error);
  }
};
